import { Container, Col } from "react-bootstrap";
import SectionHeading from "../ui/SectionHeading";
import { RevealGroup, RevealItem } from "../ui/Reveal";
import "../style/VisionMission.css";

const MISSION_ITEMS = [
  "To provide fresh, high-quality, and preservative-free products that make home cooking easier and healthier.",
  "To honor traditional food preparation techniques, ensuring rich texture and authentic taste.",
  "To continuously innovate and expand our product range, catering to the evolving tastes and preferences of our customers.",
  "To maintain the highest standards of hygiene and packaging, ensuring freshness and convenience with every pack.",
];

const VisionMission = () => {
  return (
    <section className="section-pad vision-mission">
      <Container className="container-narrow">
        <SectionHeading eyebrow="What Drives Us" title="Vision &amp; Mission" />
        <RevealGroup className="row g-4">
          <Col lg={5}>
            <RevealItem className="vision-mission__card card-surface">
              <h3>Our Vision</h3>
              <p className="vision-mission__quote">
                &ldquo;To bring the authentic taste of traditional Indian food
                to every household by using high-quality and locally sourced
                ingredients, ensuring convenience without compromising on
                taste or nutrition.&rdquo;
              </p>
            </RevealItem>
          </Col>
          <Col lg={7}>
            <RevealItem delay={80} className="vision-mission__card card-surface">
              <h3>Our Mission</h3>
              <ul className="vision-mission__list">
                {MISSION_ITEMS.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </RevealItem>
          </Col>
        </RevealGroup>
      </Container>
    </section>
  );
};

export default VisionMission;
